import { render } from "./dashboardheader.vue?vue&type=template&id=9cfdc5ce"
import script from "./dashboardheader.vue?vue&type=script&lang=js"
export * from "./dashboardheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__